(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		connectedCallback() {
			this.handleClickOutside = this.handleClickOutside.bind(this);
			document.addEventListener('click', this.handleClickOutside);
		}
		
		disconnectedCallback() {
			document.removeEventListener('click', this.handleClickOutside);
		}
		
		handleClickOutside(event) {
			if (!this.contains(event.target)) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if(this.header.classList.contains('header-overlay')){
			this.header.classList.remove('color-background-4');
			this.header.classList.add('overlay-effect');
			this.header.classList.remove('color-background-overlay');
		}
		const headerMobile = document.querySelector('.header-mobile-section');

		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.remove('color-background-4');
			headerMobile.classList.add('overlay-effect');
			headerMobile.classList.remove('color-background-overlay');
		}
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		const headerMobile = document.querySelector('.header-mobile-section');
		
		if(this.header.classList.contains('header-overlay')){
			this.header.classList.add('color-background-4');
			this.header.classList.remove('color-background-1');
			this.header.classList.remove('overlay-effect');
			this.header.classList.add('color-background-overlay');
		}
		
		if(headerMobile.classList.contains('header-overlay')){
			headerMobile.classList.add('color-background-4');
			headerMobile.classList.remove('color-background-1');
			headerMobile.classList.remove('overlay-effect');
			headerMobile.classList.add('color-background-overlay');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
			constructor() {
				super();
			}
			hide() {
				super.hide();
				window.pauseAllMedia();
			}
			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			
			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-protection"] && !Shopify.designMode) return;
  try {
    
  class PasswordProtection {
    constructor() {
      this.modal = document.getElementById('password-protection-modal');
      this.form = document.getElementById('password-protection-form');
      this.input = document.getElementById('password-input');
      this.errorEl = document.getElementById('password-error');
      this.successEl = document.getElementById('password-success');
      this.closeBtn = this.modal ? this.modal.querySelector('.password-modal__close') : null;
      this.overlay = this.modal ? this.modal.querySelector('.password-modal__overlay') : null;

      this.settings = window.passwordProtectionSettings || {};
      this.sessionDuration = (this.settings.sessionDuration || 24) * 60 * 60 * 1000;
      this.context = null;

      this.init();
    }

    init() {
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hideModal());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.hideModal();
        });
      }

      document.addEventListener('click', (e) => this.handleTriggerClick(e));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal && this.modal.style.display !== 'none') {
          this.hideModal();
        }
      });
    }

    showModal(context) {
      this.context = context;
      if (this.input) this.input.value = '';
      if (this.errorEl) this.errorEl.style.display = 'none';
      if (this.successEl) this.successEl.style.display = 'none';

      if (this.modal) {
        this.modal.style.display = '';
        document.body.style.overflow = 'hidden';
      }

      if (this.input) {
        setTimeout(() => this.input.focus(), 100);
      }
    }

    hideModal() {
      if (this.modal) {
        this.modal.style.display = 'none';
        document.body.style.overflow = '';
      }
      this.context = null;
    }

    handleTriggerClick(event) {
      var btn = event.target.closest('.password-protection-button');
      if (!btn) return;

      event.preventDefault();
      var type = btn.getAttribute('data-password-type');
      var id = btn.getAttribute('data-password-id');
      var customPassword = btn.getAttribute('data-password-custom') || '';
      var contentSelector = btn.getAttribute('data-password-content-selector');
      var overlaySelector = btn.getAttribute('data-password-overlay-selector');

      window.showPasswordModal(type, id, {
        productPassword: customPassword,
        contentSelector: contentSelector,
        overlaySelector: overlaySelector
      });
    }

    handleSubmit(e) {
      e.preventDefault();
      var password = this.input ? this.input.value.trim() : '';
      if (!password) return;

      if (this.validatePassword(password)) {
        this.onPasswordSuccess(password);
      } else {
        this.showError();
      }
    }

    validatePassword(password) {
      if (!this.context) return false;

      var decodePassword = function(encoded) {
        try { return atob(encoded); }
        catch(e) { return ''; }
      };

      var inputLower = password.toLowerCase();

      if (this.context.type === 'store') {
        var stored = decodePassword(this.settings.storePassword || '');
        return inputLower === stored.toLowerCase();
      }

      if (this.context.type === 'product') {
        if (this.context.productPassword) {
          if (inputLower === this.context.productPassword.toLowerCase()) return true;
        }
        var globalProduct = decodePassword(this.settings.productPassword || '');
        return inputLower === globalProduct.toLowerCase();
      }

      return false;
    }

    onPasswordSuccess(password) {
      this.storeSession(this.context.type, this.context.id, password);

      if (this.successEl) {
        this.successEl.style.display = '';
        setTimeout(() => {
          if (this.successEl) this.successEl.style.display = 'none';
        }, 2000);
      }

      var ctx = this.context;

      if (ctx && ctx.onSuccess) {
        ctx.onSuccess();
      } else if (ctx && ctx.type === 'store') {
        window.location.reload();
        return;
      } else if (ctx) {
        this.showProtectedContent(ctx);
        this.reinitializeGalleries();
      }

      this.hideModal();
    }

    showProtectedContent(context) {
      if (context.contentSelector) {
        var contentEl = document.querySelector(context.contentSelector);
        if (contentEl) contentEl.style.display = '';
      }

      var hideStyle = document.getElementById('password-hide-style-' + context.type + '-' + context.id);
      if (hideStyle) hideStyle.remove();

      var immediateStyle = document.getElementById('password-immediate-unlock-' + context.type + '-' + context.id);
      if (immediateStyle) immediateStyle.remove();

      if (context.overlaySelector) {
        var overlays = document.querySelectorAll(context.overlaySelector);
        overlays.forEach(function(el) { el.remove(); });
      }

      window.dispatchEvent(new Event('resize'));
    }

    storeSession(type, id, password) {
      var storageKey = 'password_' + type + '_' + id;
      var durationMs = this.sessionDuration;
      var durationSec = Math.floor(durationMs / 1000);

      try {
        document.cookie = storageKey + '=1; Max-Age=' + durationSec + '; Path=/; SameSite=Lax';
      } catch(e) {}

      var data = {
        password: password,
        timestamp: Date.now(),
        expires: Date.now() + durationMs
      };

      try {
        localStorage.setItem(storageKey, JSON.stringify(data));
      } catch(e) {}

      try {
        sessionStorage.setItem(storageKey, JSON.stringify(data));
      } catch(e) {}
    }

    isPasswordStored(type, id) {
      var storageKey = 'password_' + type + '_' + id;

      try {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          if (cookies[i].trim().indexOf(storageKey + '=') === 0) return true;
        }
      } catch(e) {}

      try {
        var ls = localStorage.getItem(storageKey);
        if (ls) {
          var data = JSON.parse(ls);
          if (data.expires && data.expires > Date.now()) return true;
          localStorage.removeItem(storageKey);
        }
      } catch(e) {}

      try {
        var ss = sessionStorage.getItem(storageKey);
        if (ss) {
          var data = JSON.parse(ss);
          if (data.expires && data.expires > Date.now()) return true;
          sessionStorage.removeItem(storageKey);
        }
      } catch(e) {}

      return false;
    }

    reinitializeGalleries() {
      document.body.offsetHeight;

      setTimeout(function() {
        document.querySelectorAll('.swiper').forEach(function(el) {
          if (el.swiper) {
            try { el.swiper.destroy(true, true); } catch(e) {}
          }
        });

        window.dispatchEvent(new Event('resize'));
      }, 150);

      setTimeout(function() {
        document.querySelectorAll('.swiper').forEach(function(el) {
          if (el.swiper) {
            try { el.swiper.update(); } catch(e) {}
          }
        });

        if (window.jQuery) {
          window.jQuery(window).trigger('resize');
        }

        window.dispatchEvent(new Event('resize'));
      }, 500);
    }

    checkAccess(type, id, options) {
      if (this.isPasswordStored(type, id)) {
        if (options && options.onSuccess) {
          options.onSuccess();
        }
        return;
      }

      this.showModal({
        type: type,
        id: id,
        productPassword: options ? options.productPassword : '',
        contentSelector: options ? options.contentSelector : '',
        overlaySelector: options ? options.overlaySelector : '',
        onSuccess: options ? options.onSuccess : null
      });
    }
  }

  window.passwordProtection = new PasswordProtection();

  window.showPasswordModal = function(type, id, messageOrOptions, customPassword, contentSelector, overlaySelector) {
    var options = {};

    if (typeof messageOrOptions === 'object' && messageOrOptions !== null) {
      options = messageOrOptions;
    } else {
      options = {
        message: messageOrOptions,
        productPassword: customPassword,
        contentSelector: contentSelector,
        overlaySelector: overlaySelector
      };
    }

    var originalOnSuccess = options.onSuccess;

    options.onSuccess = function() {
      var successEl = document.getElementById('password-success');
      if (successEl) {
        successEl.style.display = '';
        setTimeout(function() { successEl.style.display = 'none'; }, 2000);
      }

      if (options.contentSelector) {
        var contentEl = document.querySelector(options.contentSelector);
        if (contentEl) contentEl.style.display = '';
      }

      var hideStyle = document.getElementById('password-hide-style-' + type + '-' + id);
      if (hideStyle) hideStyle.remove();

      var immediateStyle = document.getElementById('password-immediate-unlock-' + type + '-' + id);
      if (immediateStyle) immediateStyle.remove();

      var overlay = document.getElementById('password-overlay-' + type + '-' + id);
      if (overlay) overlay.remove();

      if (window.passwordProtection && typeof window.passwordProtection.reinitializeGalleries === 'function') {
        window.passwordProtection.reinitializeGalleries();
      }

      if (typeof originalOnSuccess === 'function') {
        originalOnSuccess();
      }
    };

    window.passwordProtection.checkAccess(type, id, options);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function() {
		function appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
	}
	
		//window.addEventListener('resize', appHeight);
		appHeight();
	});

  } catch(e) { console.error(e); }
})();
})();
